import React from 'react'
import '../styles/servicesComp.css'
import { NavLink } from 'react-router-dom'

function ServicesComp() {
    return (
        <div className='containerServicesComp container-xxl pt-3 pb-5'>
            <div className='text-center tittle-1'>

                <span>Áreas de </span><span className='fw-bold'>práctica</span>

                <div className='pa-1 pt-3 pb-3'>Comprometidos con la excelencia, ofrecemos soluciones jurídicas adaptadas a sus necesidades en cada <span className='fw-bold'>área de práctica</span>, garantizando profesionalismo, experiencia y resultados</div>


                <div className='container-card pt-4'>

                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Penal-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Derecho Penal</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>

                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Familia-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Derecho de familia y sucesiones</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>

                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Civil-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Derecho Civil</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>

                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Laboral-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Derecho Laboral y Seguridad Social</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>

                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Administrativo-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Derecho Administrativo, Corporativo y Regulatorio</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>


                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Electoral-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Derecho Público, Electoral y Sancionatorio</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>

                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Controversias-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Métodos Alternativos de Solución de Controversias</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>

                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Privado-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Derecho Privado, Derecho Corporativo y Litigios</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>

                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Industrial-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Propiedad Industrial, Tecnología y Derecho del
                            Entretenimiento</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>

                    <div className='card-services pt-2'>
                        <div><img src={`${process.env.PUBLIC_URL}/img/servicesComp/Migratorio-DEFIENDEME.svg`} className="icon" alt="Defiendeme" /></div>
                        <div className='card-services-tittle mt-3 mb-3'>Derecho Migratorio</div>
                        <div className='mb-4'><NavLink to="/services" className="card-services-button">Ver más {` ➔`} </NavLink></div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ServicesComp
